import api from './api';

export interface PlanilhaOrcadoEconomico {
  id: string;
  revisao: number;
  numero: number;
  observacao: string;
  ano: number;
  dataAprovacao: Date;
  statusPlanilha: string;
  possuiPlanilhaOrcadoEconomico?: boolean;
  tabelaPlanilhaOrcadoEconomico: any;
  momeColunasDinamicas?: string[];
  columnProps?: ColumnProps[];
}

export interface DadoPlanilhaOrcadoEconomico {
  numberIndex: number;
  oi: string;
  numero: number;
  revisao: number;
  dataAprovacao: string;
  ano: number;
  mes: number;
  mesAno: string;
  valor: string;
  oiTipoInteiro?: number;
}

export interface ColumnProps {
  title: string;
  dataIndex: string;
  width: string;
}

export interface PlanilhaOrcadoEconomicoFormProps {
  id?: string;
  file: any;
  numero: number;
  revisao: string;
  dataAprovacao: string;
  observacao: string;
}

export const getPlanilhaOrcadoEconomicoAnoMesByProjetoId = (id: string) =>
  api.get<PlanilhaOrcadoEconomico>(`orcamentos/planilhas/orcadoEconomico/${id}`);

export const getAllPlanilhasOrcadoEconomicoAnoMes = () =>
  api.get<PlanilhaOrcadoEconomico[]>(`orcamentos/planilhas/orcadoEconomico`);

export const verificarSeExitePlanilha = (id: string) => api.get<boolean>(`exportar/verificarSeExitePlanilha/${id}`);

export const createPlanilhaOrcamento = (formValues: PlanilhaOrcadoEconomicoFormProps, file: any) => {
  const form = new FormData();

  form.append('file', file);
  form.append('id', formValues.id || '');
  form.append('numero', formValues.numero.toString());
  form.append('revisao', formValues.revisao.toString());
  form.append('observacao', formValues.observacao || '');
  form.append('dataAprovacao', String(formValues.dataAprovacao));

  return api.post<PlanilhaOrcadoEconomico>(`orcamentos/planilhas/orcadoEconomico`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const updatePlanilhaOrcadoEconomicoAnoMes = (formValues: PlanilhaOrcadoEconomicoFormProps) =>
  api.put<PlanilhaOrcadoEconomico>(`orcamentos/planilhas/orcadoEconomico`, formValues);
